module.exports = __webpack_public_path__ + "img/palabras-excluidas.4b302254.png";